"use client"

import { useState, useEffect } from "react"
import { Preferences } from "@capacitor/preferences"

export interface OnboardingData {
  firstName: string;
  lastName: string;
  countryCode: string;
  username: string;
  gender: string;
  motivation: string;
  handicap: number | null;
  imageUrl: string | null;
  membership: number | null;
}

export const useOnboarding = () => {
  const [onboardingData, setOnboardingData] = useState<OnboardingData>({
    firstName: '',
    lastName: '',
    countryCode: 'FR',
    username: '',
    gender: '',
    motivation: '',
    handicap: 54,
    membership: null,
    imageUrl: null
  })
  const [completedSteps, setCompletedSteps] = useState<string[]>([])

  useEffect(() => {
    loadOnboardingData()
  }, [])

  const loadOnboardingData = async () => {
    const storedData = await Preferences.get({ key: "onboardingData" })
    const storedSteps = await Preferences.get({ key: "completedSteps" })
    if (storedData.value) {
      setOnboardingData(JSON.parse(storedData.value))
    }
    if (storedSteps.value) {
      setCompletedSteps(JSON.parse(storedSteps.value))
    }
  }

  const updateOnboardingData = async (newData: Partial<OnboardingData>) => {
    const updatedData = { ...onboardingData, ...newData }
    setOnboardingData(updatedData)
    await Preferences.set({
      key: "onboardingData",
      value: JSON.stringify(updatedData),
    })
  }

  const completeStep = async (step: string) => {
    if (!completedSteps.includes(step)) {
      const updatedSteps = [...completedSteps, step]
      setCompletedSteps(updatedSteps)
      await Preferences.set({
        key: "completedSteps",
        value: JSON.stringify(updatedSteps),
      })
    }
  }

  return { onboardingData, updateOnboardingData, completedSteps, completeStep }
}
